import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import ApprovalRewards from "./index";
import { MODULE_APPROVAL_REWARDS } from "variables/modules";

const approvalRewardRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Approval Rewards",
        basePath: "approval-rewards",
        mainComponent: <ApprovalRewards />,
        layout: "/console",	   
        subTitle:"Approval Rewards",
        level:5,
        moduleId: MODULE_APPROVAL_REWARDS,
    })
]

export default approvalRewardRoutes;